import { PropsWithoutRef } from "react";
import {
  Drawer,
  Toolbar,
  List,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  Box,
  IconButton,
  Tooltip,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import { SIDEBAR_WIDTH } from "../constants";

interface Props {
  mobileOpen: boolean;
  handleSidebarToggle: () => void;
}

export default function Sidebar({
  mobileOpen,
  handleSidebarToggle,
}: PropsWithoutRef<Props>) {
  const location = useLocation();
  const navigate = useNavigate();

  const drawer = (
    <>
      <Toolbar className="sidebar-logo" sx={{ position: "relative" }}>
        <a
          href="/dashboard"
          onClick={(e) => {
            e.preventDefault();
            navigate("/dashboard");
          }}
          className="logo_link"
        >
          <figure>
            {/* <img src="/static/images/ozri_logo.svg" alt="Barber Shop Logo" /> */}
            <figcaption>Barber Shop</figcaption>
            <figcaption className="logo_sm">BS</figcaption>
          </figure>
        </a>

        <IconButton
          sx={{
            display: "none",
            position: "absolute",
            top: "10px",
            right: "10px",
          }}
          onClick={handleSidebarToggle}
        >
          <MenuIcon />
        </IconButton>
      </Toolbar>

      <List sx={{ flexGrow: 1 }} className="sidebr-lst">
        <Tooltip title="Dashboard" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={location.pathname === "/dashboard"}
            onClick={() => navigate("/dashboard")}
          >
            <ListItemIcon>
              <img src="/static/images/dashboard_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Dashboard" />
          </ListItemButton>
        </Tooltip>

        <Tooltip title="Manage Customers" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === "/manage-users" ||
              location.pathname === "/manage-users/edit" ||
              location.pathname === "/manage-users/detail"
            }
            onClick={() => navigate("/manage-users")}
          >
            <ListItemIcon>
              <img src="/static/images/user_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Manage Customers" />
          </ListItemButton>
        </Tooltip>

        <Tooltip title="Manage Service Providers" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={location.pathname === "/manage-service-providers"}
            onClick={() => navigate("/manage-service-providers")}
          >
            <ListItemIcon>
              <img src="/static/images/provider.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText
              className="lstitm-txt"
              primary="Manage Service Providers"
            />
          </ListItemButton>
        </Tooltip>

        <Tooltip title="Manage Services" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === "/manage-service-categories" ||
              location.pathname === "/manage-service-categories/sub-categories"
            }
            onClick={() => navigate("/manage-service-categories")}
          >
            <ListItemIcon>
              <img src="/static/images/services.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText
              className="lstitm-txt"
              primary="Manage Services"
            />
          </ListItemButton>
        </Tooltip>
        <Tooltip title="Booking Management" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === "/manage-bookings" ||
              location.pathname === "/manage-bookings/view"
            }
            onClick={() => navigate("/manage-bookings")}
          >
            <ListItemIcon>
              <img src="/static/images/booking.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Booking Management" />
          </ListItemButton>
        </Tooltip>
        <Tooltip title="GeoFencing" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === "/geofencing" ||
              location.pathname === "/geofencing/add"
            }
            onClick={() => navigate("/geofencing")}
          >
            <ListItemIcon>
              <img src="/static/images/location_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="GeoFencing" />
          </ListItemButton>
        </Tooltip>

        <Tooltip title="Subscription Plans" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={location.pathname === "/manage-subscriptions"}
            onClick={() => navigate("/manage-subscriptions")}
          >
            <ListItemIcon>
              <img src="/static/images/subscription_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText
              className="lstitm-txt"
              primary="Subscription Plans"
            />
          </ListItemButton>
        </Tooltip>

        <Tooltip title="Report and Analytics" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={location.pathname === "/manage-reports"}
            onClick={() => navigate("/manage-reports")}
          >
            <ListItemIcon>
              <img src="/static/images/status_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Report and Analytics" />
          </ListItemButton>
        </Tooltip>

        <Tooltip title="Manage Reviews" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={location.pathname === "/manage-reviews"}
            onClick={() => navigate("/manage-reviews")}
          >
            <ListItemIcon>
              <img src="/static/images/subscription_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Manage Reviews" />
          </ListItemButton>
        </Tooltip>

        <Tooltip title="Loyalty & Promotions" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={location.pathname === "/manage-loyalty"}
            onClick={() => navigate("/manage-loyalty")}
          >
            <ListItemIcon>
              <img src="/static/images/loyalty.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText
              className="lstitm-txt"
              primary="Loyalty & Promotions"
            />
          </ListItemButton>
        </Tooltip>



        <Tooltip title="Revenue Management" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={location.pathname === "/manage-revenue"}
            onClick={() => navigate("/manage-revenue")}
          >
            <ListItemIcon>
              <img src="/static/images/money_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Revenue Management" />
          </ListItemButton>
        </Tooltip>

        <Tooltip title="Manage Sub-Admin" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === "/manage-subadmin" ||
              location.pathname === "/manage-subadmin/add" ||
              location.pathname === "/manage-subadmin/detail" ||
              location.pathname === "/manage-subadmin/roles" ||
              location.pathname === "/manage-subadmin/roles/add" ||
              location.pathname === "/manage-subadmin/roles/detail"
            }
            onClick={() => navigate("/manage-subadmin")}
          >
            <ListItemIcon>
              <img src="/static/images/user_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Manage Sub-Admin" />
          </ListItemButton>
        </Tooltip>
        <Tooltip title="Manage Customer Support" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={location.pathname === "/manage-customer-support"}
            onClick={() => navigate("/manage-customer-support")}
          >
            <ListItemIcon>
              <img src="/static/images/support_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText
              className="lstitm-txt"
              primary="Manage Customer Support"
            />
          </ListItemButton>
        </Tooltip>

        <Tooltip title="Notification Management" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={location.pathname === "/manage-notifications"}
            onClick={() => navigate("/manage-notifications")}
          >
            <ListItemIcon>
              <img src="/static/images/notification2_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText
              className="lstitm-txt"
              primary="Notification Management"
            />
          </ListItemButton>
        </Tooltip>
        <Tooltip title="Manage CMS Pages" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={location.pathname === "/manage-cms"}
            onClick={() => navigate("/manage-cms")}
          >
            <ListItemIcon>
              <img src="/static/images/cms_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Manage CMS Pages" />
          </ListItemButton>
        </Tooltip>
      </List>
    </>
  );
  return (
    <Box
      component="nav"
      sx={{
        width: mobileOpen ? SIDEBAR_WIDTH : 0,
        transition: "width 0.3s",
        overflowX: "hidden",
      }}
      className={mobileOpen ? "sidebar-main-div active" : "sidebar-main-div"}
    >
      <Drawer
        className="sidebar_drawer"
        variant="persistent"
        sx={{
          // display: { xs: "none", lg: "block" },
          "& .MuiDrawer-paper": {
            width: SIDEBAR_WIDTH,
            boxSizing: "border-box",
          },
        }}
        open
      >
        {drawer}
      </Drawer>
      {/* <Drawer
        variant="permanent"
        className="sidebar_drawer"
        sx={{
          display: { xs: "none", lg: "block" },
          "& .MuiDrawer-paper": {
            width: SIDEBAR_WIDTH,
            boxSizing: "border-box",
          },
        }}
        open
      >
        {drawer}
      </Drawer> */}
    </Box>
  );
}
